var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0C13.3687 0 11.625 1.74375 11.625 3.875V58.125C11.625 60.2562 13.3687 62 15.5 62H54.25C56.3812 62 58.125 60.2562 58.125 58.125V15.5L42.625 0H15.5Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 15.5H58.125L42.625 0V11.625C42.625 13.7563 44.3687 15.5 46.5 15.5Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.125 27.125L46.5 15.5H58.125V27.125Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.375 50.375C50.375 51.4406 49.5031 52.3125 48.4375 52.3125H5.8125C4.74687 52.3125 3.875 51.4406 3.875 50.375V31C3.875 29.9344 4.74687 29.0625 5.8125 29.0625H48.4375C49.5031 29.0625 50.375 29.9344 50.375 31V50.375Z",
    fill: "#F8A600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4375 52.3125H11.625V54.25H48.4375C49.5031 54.25 50.375 53.3781 50.375 52.3125V50.375C50.375 51.4406 49.5031 52.3125 48.4375 52.3125Z",
    fill: "#CAD1D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0492 44.845C30.1092 44.975 30.1392 45.105 30.1392 45.235C30.1392 45.465 30.0442 45.66 29.8542 45.82C29.6742 45.98 29.4642 46.06 29.2242 46.06C29.0642 46.06 28.9142 46.02 28.7742 45.94C28.6342 45.85 28.5242 45.715 28.4442 45.535L27.5442 43.525H22.2642L21.3642 45.535C21.2842 45.715 21.1742 45.85 21.0342 45.94C20.8942 46.02 20.7392 46.06 20.5692 46.06C20.3392 46.06 20.1292 45.98 19.9392 45.82C19.7492 45.66 19.6542 45.465 19.6542 45.235C19.6542 45.105 19.6842 44.975 19.7442 44.845L23.8842 35.95C23.9742 35.75 24.1092 35.6 24.2892 35.5C24.4792 35.39 24.6792 35.335 24.8892 35.335C25.0992 35.335 25.2942 35.39 25.4742 35.5C25.6642 35.6 25.8042 35.75 25.8942 35.95L30.0492 44.845ZM22.9242 42.025H26.8842L24.9042 37.57L22.9242 42.025ZM32.557 46.09C32.267 46.09 32.032 46 31.852 45.82C31.682 45.64 31.597 45.405 31.597 45.115V36.31C31.597 36.02 31.682 35.79 31.852 35.62C32.032 35.44 32.267 35.35 32.557 35.35C32.857 35.35 33.092 35.44 33.262 35.62C33.442 35.79 33.532 36.02 33.532 36.31V45.115C33.532 45.405 33.442 45.64 33.262 45.82C33.092 46 32.857 46.09 32.557 46.09Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAi);
export default __webpack_public_path__ + "static/media/ic_ai.a1ad0a84b08e872ab25463a9b02481be.svg";
export { ForwardRef as ReactComponent };